import Reveal from '@/components/base/Reveal';
import CtaLink from '@/pages/home/components/CtaLink';

export default function RoiVisual() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            <i className="ri-calculator-line"></i>
            The ROI Logic
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Marketing Spend Is Only Useful When It Produces Business Results.
          </h2>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 rounded-2xl border border-white/10 bg-background-100 p-6 md:p-10">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6">
              {/* Investment */}
              <div className="w-full md:w-auto text-center rounded-xl border border-white/8 bg-background-200/60 px-8 py-6">
                <p className="text-xs text-foreground-600">Marketing + Ad Investment</p>
                <p className="mt-2 font-heading font-extrabold text-3xl text-foreground-950">
                  $10,000
                </p>
              </div>

              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-primary-400">
                <i className="ri-arrow-right-line text-xl"></i>
              </span>

              {/* Benchmark */}
              <div className="w-full md:w-auto text-center rounded-xl border border-white/8 bg-background-200/60 px-8 py-6">
                <p className="text-xs text-foreground-600">Historical Benchmark</p>
                <p className="mt-2 font-heading font-extrabold text-3xl text-primary-400">12x</p>
              </div>

              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-primary-400">
                <i className="ri-arrow-right-line text-xl"></i>
              </span>

              {/* Revenue */}
              <div className="w-full md:w-auto text-center rounded-xl border border-primary-500/30 bg-primary-500/10 px-8 py-6">
                <p className="text-xs text-foreground-600">Illustrative Revenue</p>
                <p className="mt-2 font-heading font-extrabold text-3xl text-accent-400">
                  $120,000
                </p>
              </div>
            </div>

            <p className="mt-8 text-center text-xs text-foreground-600 max-w-2xl mx-auto">
              Based on selected historical campaign performance. This is not a guarantee of future
              results.
            </p>

            <div className="mt-6 text-center">
              <CtaLink href="/#roi-calculator" variant="secondary">
                Try the ROI Calculator
              </CtaLink>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}